import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import SelectChip from '../../../form/component/SelectChip'
import currentUserHasAccess from '../../../../util/widget-helper'
import { PATIENT_SCANNED_WIDGET } from '../../ui-definition/process-ui'
import Input from "../../../form/component/Input";

const PATIENT_SCANNED_VALUE = [
    {
        value: true,
        label: 'Yes',
    },
    {
        value: false,
        label: 'No',
    },
]

const PatientScannedWidget = ({
    readOnly,
    context,
    changeProcessContext,
    saveProcessContext,
    validationMessageList,
    isSaveNeeded = false,
}) => {
    if (!currentUserHasAccess(PATIENT_SCANNED_WIDGET)) {
        return null
    }

    return (
        <ContentBox title=" Patient Scanned">
            <Row>
                <Column size={6}>
                    <LabelInput label="">
                        <SelectChip
                            object={context}
                            name="patientScanned"
                            readOnly={readOnly}
                            addEmpty={true}
                            valueList={PATIENT_SCANNED_VALUE}
                            onChange={(name, value) => {
                                changeProcessContext('patientScanned', value)
                                if (isSaveNeeded) {
                                    saveProcessContext()
                                }
                            }}
                        />
                    </LabelInput>
                </Column>
                <Column size={4}>
                    <LabelInput label="Scanned by">
                        <Input name="scannedBy" object={context} readOnly={readOnly} onChange={(name, value) => {
                            changeProcessContext('scannedBy', value)
                            saveProcessContext()
                        }}/>
                    </LabelInput>
                </Column>
            </Row>
        </ContentBox>
    )
}

PatientScannedWidget.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    context: PropTypes.object.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    validationMessageList: PropTypes.array.isRequired,
    isSaveNeeded: PropTypes.bool,
}

export default PatientScannedWidget



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/PatientScannedWidget.js